var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.item.visible)?_c('span',{staticClass:"vp-breadcrumbs__item"},[_c('v-icon',[_vm._v("mdi-chevron-right")]),_c('v-btn',{staticClass:"btn-text btn-plain vp-breadcrumbs_btn",attrs:{"elevation":"0"},on:{"click":function($event){return _vm.$emit('click', _vm.item)}}},[_vm._v(" "+_vm._s(_vm.item.label)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }